/**
 * The portal's action row — and the one place it is hidden (Batch 0).
 *
 * ---------------------------------------------------------------------------
 * WHY THIS IS A COMPONENT AND NOT A CSS RULE
 * ---------------------------------------------------------------------------
 * It WAS a CSS rule, and the rule did not fire where it mattered:
 *
 *   portalStyles.ts:449   .pp-acts, .pp-noprint { display:none !important; }
 *
 * sits inside an `@media print` block. Chromium honours that during PDF
 * generation via emulateMediaType('print') — but a rep previewing a document
 * sees the portal in an ordinary on-screen iframe, where `@media print` does not
 * apply at all. So every client action stayed live: a rep could press Download,
 * and on the estimate portal, Accept.
 *
 * Hiding it in the RENDER closes that, and closes it for good. A component that
 * returns null cannot be defeated by a media query not matching, by a stylesheet
 * loading late, or by someone adding a third context nobody thought about.
 *
 * The CSS rule stays as well. Two mechanisms, because the cost is one line and
 * the failure being prevented is a member of staff accepting an estimate on a
 * client's behalf.
 */

import React from 'react';
import { isPrintMode } from './downloadPdf';

export function PortalActions({
  children, style, className,
}: {
  children: React.ReactNode;
  style?: React.CSSProperties;
  className?: string;
}) {
  // print=1 means somebody is looking at this who is not the client: Chromium
  // making the PDF, or a rep previewing it. Neither may act as them.
  if (isPrintMode()) return null;
  return <div className={className ?? 'pp-acts'} style={style}>{children}</div>;
}
